import React, { useState, useEffect } from "react";
import {
  Container,
  Typography,
  Paper,
  Box,
  Card,
  Tab,
  Divider,
  Tabs,
  Stack,
} from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Link } from "react-router-dom";
import "../styles/layout/LandingPage.scss";
import Technologies from "../components/technologies";
import TabContent from "../components/tabcontents";

const tabsData = [
  {
    label: "Ideation",
    title: "Ideation",
    content:
      "Our collaborative ideation session brings together your vision and our expertise. As a software development services company, we align creative ideas with your business goals and market needs, setting the stage for a successful product.",
    image: "/assets/ProductEngineering/tab1.png",
  },
  {
    label: "Design",
    title: "Design",
    content:
      "Beyond aesthetics, our design approach focuses on engaging UI/UX experiences. Our skilled designers emphasize every interaction point, ensuring user satisfaction and seamless usability.",
    image: "/assets/ProductEngineering/tab2.png",
  },
  {
    label: "Development",
    title: "Development",
    content:
      "Development is where ideas take form. Our experienced developers, versed in diverse technologies and platforms, transform concepts into tangible solutions. Our agile methodology ensures flexibility and efficient progress.",
    image: "/assets/ProductEngineering/tab3.png",
  },
  {
    label: "Testing",
    title: "Testing",
    content:
      "As a reputable custom application development company, we prioritize quality at every step. Thorough testing and analysis guarantee optimal performance and reliability.",
    image: "/assets/ProductEngineering/tab4.png",
  },
  {
    label: "Deployment",
    title: "Deployment",
    content:
      "The culmination of our efforts lies in the deployment phase. With meticulous planning, our product engineering services ensure a smooth transition to the market.",
    image: "/assets/ProductEngineering/tab5.png",
  },
];


const ProductEngineering = () => {
  // State to track the active tab
  const [selectedTab, setSelectedTab] = useState(0);

  // Function to handle tab change
  const handleChange = (event, newValue) => {
    setSelectedTab(newValue);
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Box sx={{ display: "flex", flexDirection: "column", overflowX: "hidden" }}>
      <Paper
        elevation={0}
        sx={{
          backgroundImage: 'url("/assets/ProductEngineering/background.png")',
          backgroundPosition: "center",
          backgroundSize: "cover",
          maxWidth: "100%",
          height: "480px",
          display: "flex",
          overflowX: "hidden",
        }}
      >
        <Container
          disableGutters
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            maxWidth: "lg",
            margin: "0 0 0 10%",
          }}
        >
          <Typography
            sx={{
              fontFamily: "Orbitron",
              fontWeight: "800",
              fontSize: { xs: "36px", sm: "48px", md: "60px" }, // Font size for different screen sizes
              color: "#F005A2",
              lineHeight: "120%",
              letterSpacing: "2%",
              display: "flex",
              paddingBottom: "2%",
            }}
          >
            Product Engineering Services
          </Typography>

          <Typography
            sx={{
              fontFamily: "Orbitron",
              fontWeight: "800",
              fontSize: { xs: "18px", sm: "20px", md: "24px" }, // Font size for different screen sizes
              color: "#FFFFFF",
              lineHeight: "120%",
              letterSpacing: "2%",
              display: "flex",
              justifyContent: "flex-start",
              paddingBottom: "5%",
              padding: { xs: "10px", sm: "15px", md: "20px" },
              marginBottom: { xs: "20px" }, // Padding for different screen sizes
            }}
          >
            Offering expert MVP deployment and Speed-to-Market excellence
          </Typography>

          <Link
            to="/clientForm"
            style={{
              display: "flex",
              width: "150.84px",
              height: "52.23px",
              backgroundColor: "#F005A2",
              borderRadius: "45.25px",
              opacity: "100%",
              alignItems: "center",
              justifyContent: "center",
              padding: "0 2% 0 2%",
              textDecoration: "none",
              color: "inherit",
            }}
          >
            <div
              style={{
                fontFamily: "'Plus Jakarta Sans', sans-serif",
                fontSize: "18px",
                letterSpacing: "8%",
                fontWeight: "700",
              }}
            >
              Talk to Us
            </div>
            <div
              className="submitBtn__Arrow"
              style={{
                width: "32.84px",
                height: "32.23px",
                backgroundColor: "#FFFFFF",
                borderRadius: "45.25px",
                opacity: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginLeft: "7%",
              }}
            >
              <ArrowForwardIcon></ArrowForwardIcon>
            </div>
          </Link>
        </Container>
      </Paper>

      <Box sx={{ textAlign: "center", margin: { xs: "0 4%", md: "0 5%" } }}>
        <Box
          sx={{
            maxWidth: "100% !important",
            height: "auto",
            marginTop: { xs: "4%", md: "6%" },
          }}
        >
          {/* Title */}
          <Typography
            sx={{
              fontFamily: "Orbitron",
              fontWeight: "800",
              fontSize: { xs: "24px", md: "40px" }, // Responsive font size
              color: "#000000",
              lineHeight: "120%",
              letterSpacing: "2%",
              display: "flex",
              justifyContent: "center",
              paddingBottom: "1%",
              textAlign: "center", // Center text on mobil
              marginBottom: { xs: "20px" }, // Margin for different screen sizes
              marginTop: { xs: "20px" }, // Margin for different screen sizes
            }}
          >
            Creating Competitive Advantage through Product Development
          </Typography>

          {/* Description */}
          <Typography
            sx={{
              fontFamily: "Inter",
              fontWeight: "lighter",
              fontSize: { xs: "12px", md: "20px" }, // Responsive font size
              color: "#000000",
              display: "flex",
              justifyContent: { xs: "center", md: "flex-start" }, // Center on mobile, left on larger screens
              textAlign: { xs: "center", md: "left" },
              lineHeight: "150%",
            }}
          >
            Tecloq specializes in fast-tracking your product’s journey from
            concept to market dominance with its MVP development services. We
            specialize in minimizing costs and maximizing your path to a
            successful product launch, offering unparalleled services to turn
            your concepts into reality, making your software a cornerstone of
            your success. Whether you’re seeking customized software,
            development support, or technology consulting, our adept Software
            Product Engineering team is tailored to deliver your unique vision.
            In a landscape of escalating market competition and evolving
            customer demands, businesses and enterprises require technology
            partners who can help them build not just good, but exceptional,
            innovative, and distinctive products. At Tecloq, a renowned product
            engineering services company, we understand this need intimately.
            With a deep understanding of domain knowledge, efficient processes,
            and a dedicated team, we stand as your technology partner. We craft
            software products that truly enrich customer experiences.
          </Typography>
        </Box>
      </Box>

      {/* Services */}

      <Box
        sx={{
          maxWidth: "100% !important",
          height: "auto",
          marginTop: { xs: "4%", md: "8%" }, // Responsive top margin
          textAlign: "center",
        }}
      >
        <Typography
          sx={{
            fontFamily: "Orbitron",
            fontWeight: "800",
            fontSize: { xs: "24px", md: "40px" }, // Responsive font size
            color: "#000000",
            lineHeight: "120%",
            letterSpacing: "2%",
            display: "flex",
            paddingBottom: "1%",
            justifyContent: "center",
            textAlign: "center", // Ensure proper centering
            marginTop: { xs: "20px" }, // Margin for different screen sizes
            marginBottom: { xs: "20px" }, // Margin for different screen sizes
          }}
        >
          Our Product Development Services
        </Typography>
      </Box>

      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          flexWrap: { xs: "wrap", md: "wrap" },
          flexDirection: { xs: "row" },
          gap: {
            xs: "10px", // Less gap on smaller screens
            sm: "15px", // Moderate gap on tablets
            md: "20px", // Larger gap on desktops
          },
          "& > :not(style)": {
            m: 1,
            width: {
              xs: 150, // Smaller width on phones
              sm: 300, // Medium width on tablets
              md: 350, // Larger width on desktops
            },
            height: {
              xs: 120, // Smaller height on phones
              sm: 240, // Medium height on tablets
              md: 270, // Larger height on desktops
            },
          },
        }}
      >
        {[
          {
            img: "/assets/ProductEngineering/p1.gif",
            alt: "Software Product Development",
            title: "Software Product",
            subtitle: "Development",
          },
          {
            img: "/assets/ProductEngineering/p2.gif",
            alt: "Cognitive Product Support",
            title: "Cognitive Product",
            subtitle: "Support",
          },
          {
            img: "/assets/ProductEngineering/p3.gif",
            alt: "Product Sustenance & Modernization",
            title: "Product Sustenance &",
            subtitle: "Modernization",
          },
          {
            img: "/assets/ProductEngineering/p4.gif",
            alt: "Product Support & Operations",
            title: "Product Support &",
            subtitle: "Operations",
          },
          {
            img: "/assets/ProductEngineering/p5.gif",
            alt: "Product Quality Engineering",
            title: "Product Quality",
            subtitle: "Engineering",
          },
        ].map((item, index) => (
          <Paper
            key={index}
            elevation={3}
            sx={{
              borderRadius: "12px", // Modern rounding
              textAlign: "center",
              paddingBottom: "3%",
              alignContent: "center",
            }}
          >
            <Box
              component="img"
              src={item.img}
              alt={item.alt}
              loading="lazy"
              sx={{
                boxSizing: "border-box",
                width: {
                  xs: "50%", // Smaller image size on phones
                  sm: "55%", // Medium size on tablets
                  md: "60%", // Larger size on desktops
                },
                height: "auto",
                paddingTop: {
                  xs: "2%", // Smaller top padding on phones
                  sm: "8%", // Medium padding on tablets
                  md: "9%", // Larger padding on desktops
                },
              }}
            />
            <Typography
              sx={{
                fontFamily: "Inter",
                fontStyle: "normal",
                fontWeight: "700",
                fontSize: {
                  xs: "10px", // Smaller font size on phones
                  sm: "15px", // Medium font size on tablets
                  md: "16px", // Larger font size on desktops
                },
                lineHeight: "21px",
                alignItems: "center",
                textAlign: "center",
                color: "#000000",
                paddingTop: {
                  xs: "3%", // Smaller padding on phones
                  sm: "4%", // Medium padding on tablets
                  md: "5%", // Larger padding on desktops
                },
              }}
            >
              {item.title}
              <br />
              {item.subtitle}
            </Typography>
          </Paper>
        ))}
      </Box>

      <Typography
        sx={{
          fontFamily: "Orbitron",
          fontStyle: "normal",
          fontWeight: "700",
          fontSize: {
            xs: "24px", // Smaller font size on phones
            sm: "30px", // Medium font size on tablets
            md: "40px", // Larger font size on desktops
          },
          lineHeight: {
            xs: "28px", // Smaller line height on phones
            sm: "34px", // Medium line height on tablets
            md: "44px", // Larger line height on desktops
          },
          alignItems: "center",
          textAlign: "center",
          color: "#000000",
          paddingTop: {
            xs: "5%", // Smaller padding on phones
            sm: "7%", // Medium padding on tablets
            md: "8%", // Larger padding on desktops
          },
        }}
      >
        Product Engineering Process: An Agile Journey
      </Typography>

      <Container
        disableGutters
        sx={{
          display: "flex",
          margin: { xs: "", md: "5% 3% 0 10%" },
          flexDirection: { xs: "column", md: "row" },
          alignItems: { xs: "center" }, // Column on phones, row on larger screens
          padding: "0 !important",
          gap: "10%",
        }}
      >
        <Card
          sx={{
            backgroundColor: "transparent",
            boxShadow: "none",
            width: {
              xs: "100%", // Full width on phones
              sm: "100%", // Full width on tablets
              md: "50%", // Half width on desktops
            },
          }}
        >
          <Typography
            sx={{
              fontFamily: "Inter",
              fontWeight: "lighter",
              color: "#000000",
              fontSize: {
                xs: "12px", // Smaller font size on phones
                sm: "14px", // Medium font size on tablets
                md: "15px", // Larger font size on desktops
              },
              lineHeight: {
                xs: "18px", // Smaller line height on phones
                sm: "20px", // Medium line height on tablets
                md: "22px", // Larger line height on desktops
              },
              padding: {
                xs: "5%", // Padding on phones
                sm: "4%", // Padding on tablets
                md: "3%", // Padding on desktops
              },
              textAlign: {
                xs: "justify", // Justify text on phones
                sm: "justify", // Justify text on tablets
                md: "left", // Align left on desktops
              },
            }}
          >
            At Tecloq, we specialize in providing top-tier product engineering
            services that encompass the entire spectrum of software product
            development. With over 9 years of experience, our dedicated team
            excels in offering expert guidance and consultation throughout the
            journey. As a leading software product engineering services company,
            we are committed to delivering innovative solutions that drive your
            business forward. Experience the transformation that comes from
            working with a dedicated product engineering services company. We
            elevate your vision into a strategic advantage, delivering digital
            products that leave a lasting impact on businesses and users alike.
          </Typography>
        </Card>

        <Card
          sx={{
            backgroundColor: "transparent",
            boxShadow: "none",
            width: {
              xs: "100%", // Full width on phones
              sm: "100%", // Full width on tablets
              md: "50%", // Half width on desktops
            },
          }}
        >
          <img
            src="/assets/ProductEngineering/journey.png"
            alt="ourgoal"
            style={{
              height: "auto",
              width: "100%",
              margin: "0",
              borderRadius: "8px", // Optional: for a cleaner look on all screens
            }}
          />
        </Card>
      </Container>

      <Typography
        sx={{
          fontFamily: "Orbitron",
          fontWeight: "800",
          fontSize: {
            xs: "24px", // Smaller font size on phones
            sm: "32px", // Medium size on tablets
            md: "40px", // Larger size on desktops
          },
          color: "#000000",
          lineHeight: "120%",
          letterSpacing: "2%",
          display: "flex",
          justifyContent: "center",
          paddingTop: {
            xs: "3%", // Less top padding on phones
            sm: "4%", // Moderate padding on tablets
            md: "5%", // Larger padding on desktops
          },
        }}
      >
        Our Data Lake Services
      </Typography>

      {/* Tabs */}
      <Box sx={{ display: "flex", justifyContent: "center", marginTop: "3%" }}>
        <Tabs
          value={selectedTab}
          onChange={handleChange}
          centered
          sx={{
            width: "85%",
            "& .MuiTabs-flexContainer": {
              justifyContent: "center", // Center tabs when they fit
              // gap: { xs: "4px", sm: "8px" }, // Add small gaps for better spacing on smaller screens
            },
            "& .MuiTab-root": {
              fontSize: { xs: "10px", sm: "14px", md: "24px" }, // Shrink font size on smaller screens
              flexGrow: 1, // Allows tabs to shrink
              minWidth: 0, // Prevents fixed width and allows shrinking
              maxWidth: "240px", // Controls max width of each tab
              textTransform: "none",
              borderRadius: "1px",
              backgroundColor: "#E8E8E8", // Default color when not selected
              color: "#000", // Text color when not selected
              transition: "all 0.1s ease",
              padding: { xs: "4px 8px", sm: "6px 12px" }, // Adjust padding for better touch targets on mobile
              height: { xs: "36px", sm: "48px" }, // Adjust height for better touch experience
            },
            "& .MuiTab-root.Mui-selected": {
              backgroundColor: "#F005A2", // Active tab color
              color: "#FFFFFF", // Text color for selected tab
              fontWeight: "bold",
            },
            "& .MuiTabs-indicator": {
              display: "none", // Hide default Material-UI underline
            },
          }}
        >
          {tabsData.map((tab, index) => (
            <Tab
              key={index}
              label={tab.label}
              sx={{
                fontFamily: "Inter",
                fontSize: { xs: "12px", md: "46px" }, // Responsive font size
              }}
            />
          ))}
        </Tabs>
      </Box>

      {/* Divider */}
      <Divider
        sx={{ marginTop: "10px", backgroundColor: "#000000", height: "0.1%" }}
      />
      {/* Tab Content Below Divider */}
      <Box sx={{ margin: "3% 0 0 10%" }}>
        <TabContent
          title={tabsData[selectedTab].title}
          content={tabsData[selectedTab].content}
          image={tabsData[selectedTab].image}
        />
      </Box>
      <Box
        sx={{
          maxWidth: "100% !important",
          height: "auto",
          marginTop: { xs: "4%", md: "8%" },
          padding: { xs: "0 5%", md: "0" }, // Add padding on small screens to prevent edge clipping
        }}
      >
        <Typography
          sx={{
            fontFamily: "Orbitron",
            fontWeight: "800",
            fontSize: { xs: "24px", md: "40px" }, // Smaller on mobile
            color: "#000000",
            lineHeight: "120%",
            letterSpacing: "2%",
            display: "flex",
            justifyContent: "center",
            paddingBottom: { xs: "2%", md: "1%" },
            textAlign: "center",
          }}
        >
          The Tecloq Advantage
        </Typography>

        <Typography
          sx={{
            fontFamily: "Inter",
            fontWeight: "lighter",
            fontSize: { xs: "12px", md: "24px" }, // Smaller on mobile
            color: "#000000",
            display: "flex",
            justifyContent: "center",
            margin: { xs: "2% 5%", md: "1% 15% 2% 15%" }, // Less margin on mobile
            textAlign: "center",
          }}
        >
          Choosing Tecloq as your product engineering partner means embracing a
          dynamic and innovative approach to building transformative digital
          products. We stand out for several reasons.
        </Typography>
      </Box>

      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          flexWrap: "wrap",
          paddingX: { xs: "2%", md: "0" }, // Add padding on mobile
          gap: { xs: "5%", md: "3%" }, // More gap on mobile for better spacing
          "& > :not(style)": {
            m: 1,
            width: { xs: "90%", sm: "80%", md: 370 }, // Adjust width for mobile
            height: { xs: "auto", md: 700 }, // Auto height on mobile
          },
        }}
      >
        {/* Card 1 */}
        <Paper
          elevation={3}
          sx={{
            borderRadius: "3%",
            textAlign: "center",
            border: "0.5px solid #FFC3EA",
            alignContent: "center",
            boxShadow: "0px -3px 17px rgba(240, 5, 162, 0.52)",
            display: "flex",
            flexDirection: "column",
            padding: { xs: "5%", md: "0" }, // Add padding on mobile
          }}
        >
          <img
            src="/assets/AdvancedAI/TextAnalysis/why1.png"
            alt="why1"
            style={{
              width: "70%",
              height: "auto",
              padding: "10% 0 5% 15%",
              objectFit: "contain", // Maintain aspect ratio
            }}
          />
          <Typography
            sx={{
              fontFamily: "Orbitron",
              lineHeight: "120%",
              fontSize: { xs: "20px", md: "28px" }, // Smaller font size on mobile
              fontWeight: "700",
              color: "#F005A2",
              letterSpacing: "2%",
            }}
          >
            Expertise and Experience
          </Typography>
          <Typography
            sx={{
              fontFamily: "Inter",
              lineHeight: "140%",
              padding: "5% 10%", // Adjust padding for mobile
              textAlign: "center",
              fontSize: { xs: "14px", md: "16px" },
            }}
          >
            Our seasoned team of software engineers, developers, and consultants
            bring a wealth of knowledge and practical experience to the table,
            ensuring that your product development journey is guided by experts.
          </Typography>
        </Paper>

        {/* Card 2 */}
        <Paper
          elevation={3}
          sx={{
            borderRadius: "3%",
            textAlign: "center",
            border: "0.5px solid #FFC3EA",
            alignContent: "center",
            boxShadow: "0px -3px 17px rgba(240, 5, 162, 0.52)",
            display: "flex",
            flexDirection: "column",
            padding: { xs: "5%", md: "0" },
          }}
        >
          <img
            src="/assets/ProductEngineering/why2.gif"
            alt="why2"
            style={{
              width: "70%",
              height: "auto",
              padding: "10% 0 5% 15%",
              objectFit: "contain",
            }}
          />
          <Typography
            sx={{
              fontFamily: "Orbitron",
              lineHeight: "120%",
              fontSize: { xs: "20px", md: "28px" },
              fontWeight: "700",
              color: "#F005A2",
              letterSpacing: "2%",
            }}
          >
            Tailored
            <br />
            Solutions
          </Typography>
          <Typography
            sx={{
              fontFamily: "Inter",
              lineHeight: "140%",
              padding: "5% 10%",
              textAlign: "center",
              fontSize: { xs: "14px", md: "16px" },
            }}
          >
            We recognize that each project is unique. Our customized product
            development services are designed to align with your specific goals
            and challenges, ensuring that you receive a solution that perfectly
            fits your requirements.
          </Typography>
        </Paper>

        {/* Card 3 */}
        <Paper
          elevation={3}
          sx={{
            borderRadius: "3%",
            textAlign: "center",
            border: "0.5px solid #FFC3EA",
            alignContent: "center",
            boxShadow: "0px -3px 17px rgba(240, 5, 162, 0.52)",
            display: "flex",
            flexDirection: "column",
            padding: { xs: "5%", md: "0" },
          }}
        >
          <img
            src="/assets/ProductEngineering/why3.gif"
            alt="why3"
            style={{
              width: "70%",
              height: "auto",
              padding: "10% 0 5% 15%",
              objectFit: "contain",
            }}
          />
          <Typography
            sx={{
              fontFamily: "Orbitron",
              lineHeight: "120%",
              fontSize: { xs: "20px", md: "28px" },
              fontWeight: "700",
              color: "#F005A2",
              letterSpacing: "2%",
            }}
          >
            Cutting-Edge
            <br />
            Technologies
          </Typography>
          <Typography
            sx={{
              fontFamily: "Inter",
              lineHeight: "140%",
              padding: "5% 10%",
              textAlign: "center",
              fontSize: { xs: "14px", md: "16px" },
            }}
          >
            With expertise in a range of technologies including MERN, Django,
            and Angular, we leverage the latest tools and frameworks to provide
            you with the most cutting-edge and impactful product engineering
            services.
          </Typography>
        </Paper>
      </Box>

      <Box
        sx={{ maxWidth: "100% !important", height: "auto", marginTop: "8%" }}
      >
        <Typography
          sx={{
            fontFamily: "Orbitron",
            fontWeight: "800",
            fontSize: { xs: "24px", sm: "32px", md: "40px" }, // Responsive font size
            color: "#000000",
            lineHeight: "120%",
            letterSpacing: "2%",
            display: "flex",
            justifyContent: "center",
            paddingBottom: { xs: "3%", md: "1%" }, // Adjust padding for small screens
            textAlign: "center", // Ensure proper alignment on smaller screens
          }}
        >
          Related Capabilities
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          flexWrap: "wrap",
          gap: { xs: "20px", sm: "30px", md: "50px" }, // Adjust gap for better spacing on small screens
          marginTop: { xs: "5%", sm: "4%", md: "3%" },
          paddingX: { xs: "5%", md: "0" }, // Add padding on mobile
        }}
      >
        {[
          {
            imgSrc: "/assets/ProductEngineering/c1.png",
            title: "Angular",
            description:
              "Our skilled Angular developers harness the power of this versatile framework to create dynamic, high-performance web applications. With a deep understanding of Angular's components, modules, and services, we craft interactive user interfaces that provide a superior user experience.",
          },
          {
            imgSrc: "/assets/ProductEngineering/c2.png",
            title: "React",
            description:
              "With React, we build user interfaces that are both efficient and scalable. Our React developers specialize in creating component-based architectures that enable seamless updates and a more engaging user experience. From single-page applications to complex interfaces, React empowers us to deliver cutting-edge solutions.",
          },
          {
            imgSrc: "/assets/ProductEngineering/c3.png",
            title: "Python",
            description:
              "Our expertise in Python Django empowers us to develop robust and scalable web applications rapidly. Leveraging Django's high-level framework, we create feature-rich applications with a clean and maintainable codebase. With a focus on security and performance, our Python Django solutions are tailored to meet your specific needs.",
          },
        ].map((item, index) => (
          <Paper
            key={index}
            elevation={3}
            sx={{
              borderRadius: "3%",
              textAlign: "center",
              border: "0.5px solid #FFC3EA",
              alignContent: "center",
              boxShadow: "0px -3px 17px rgba(240, 5, 162, 0.52)",
              display: "flex",
              flexDirection: "column",
              background:
                "linear-gradient(153.3deg, #FFFFFF 8.98%, #FFEAF8 89.37%)",
              width: { xs: "90%", sm: "300px", md: "370px" }, // Responsive width
              height: { xs: "auto", sm: "450px", md: "500px" }, // Responsive height
              padding: { xs: "20px", sm: "30px", md: "40px" }, // Responsive padding
            }}
          >
            <img
              src={item.imgSrc}
              alt={item.title}
              style={{
                width: "20%",
                height: "auto",
                margin: "0 auto",
                paddingTop: "10%", // Adjust padding on smaller screens
              }}
            />
            <Typography
              sx={{
                fontFamily: "Orbitron",
                lineHeight: "120%",
                fontSize: { xs: "20px", sm: "24px", md: "28px" }, // Responsive font size
                fontStyle: "normal",
                fontWeight: "700",
                color: "#F005A2",
                letterSpacing: { xs: "1%", md: "2%" }, // Adjust letter spacing
                marginTop: { xs: "3%", md: "5%" }, // Adjust margin for consistency
                textAlign: "center",
              }}
            >
              {item.title}
            </Typography>

            <Typography
              sx={{
                fontFamily: "Inter",
                fontStyle: "normal",
                lineHeight: { xs: "140%", sm: "150%", md: "auto" },
                padding: {
                  xs: "5% 5% 2% 5%",
                  sm: "8% 8% 3% 8%",
                  md: "10% 10% 3% 10%",
                },
                fontSize: { xs: "14px", sm: "16px", md: "18px" },
                textAlign: "center",
              }}
            >
              {item.description}
            </Typography>
          </Paper>
        ))}
      </Box>

      <Paper
        sx={{
          background:
            "linear-gradient(90.92deg, #000000 0.5%, rgba(102, 102, 102, 0) 36.86%)",
          filter: "drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25))",
          position: "relative",
          maxWidth: "100%",
          height: { xs: "350px", sm: "420px", md: "480px" }, // Responsive height
          backgroundColor: "#7F0055",
          marginTop: "3%",
          display: "flex",
          justifyContent: "flex-start",
        }}
      >
        <img
          src="/assets/ProductEngineering/success.webp"
          loading="lazy"
          alt="Transform"
          style={{
            position: "absolute",
            top: "0",
            height: "100%", // Match parent height
            width: "auto",
            zIndex: "-1",
          }}
        />

        <Box
          sx={{
            position: "absolute",
            left: { xs: "5%", sm: "15%", md: "24%" },
            top: "50%", // Center vertically
            transform: "translateY(-50%)", // Centering fix
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            width: { xs: "90%", sm: "80%", md: "60%" },
          }}
        >
          {/* Heading */}
          <Typography
            sx={{
              fontFamily: "Orbitron",
              fontStyle: "normal",
              fontWeight: "700",
              fontSize: { xs: "20px", sm: "24px", md: "30px" },
              lineHeight: "120%",
              textAlign: "center",
              letterSpacing: "0.02rem",
              color: "#FFFFFF",
              marginBottom: { xs: "10px", sm: "15px", md: "20px" },
            }}
          >
            Let's create your next success story together!
          </Typography>

          {/* Description */}
          <Typography
            sx={{
              fontFamily: "Inter",
              textAlign: "center",
              color: "#FFFFFF",
              fontSize: { xs: "14px", sm: "16px", md: "18px" },
              padding: { xs: "0 5% 2% 5%", sm: "2% 10% 3% 10%" },
              lineHeight: { xs: "150%", sm: "160%" },
            }}
          >
            Partner with our top AWS certified developers for accelerated
            product launches, guided by dedicated Scrum masters. Tecloq, a
            leading product engineering services company, transforms ideas into
            remarkable reality for startups and Fortune 100 firms across diverse
            industries.
          </Typography>

          <Typography
            sx={{
              fontFamily: "Inter",
              textAlign: "center",
              color: "#FFFFFF",
              fontSize: { xs: "14px", sm: "16px", md: "18px" },
              padding: { xs: "0 5% 3% 5%", sm: "0 10% 3% 10%" },
            }}
          >
            Your path to innovation starts here.
          </Typography>

          {/* Button */}
          <Link
            to="/clientForm"
            style={{
              display: "flex",
              width: "fit-content",
              padding: "10px 20px",
              backgroundColor: "#F005A2",
              borderRadius: "45px",
              alignItems: "center",
              justifyContent: "center",
              textDecoration: "none",
              color: "inherit",
              fontSize: "18px",
            }}
          >
            <div
              style={{
                fontFamily: "'Plus Jakarta Sans', sans-serif",
                fontSize: "18px",
                letterSpacing: "0.08em",
                fontWeight: "700",
              }}
            >
              Know More
            </div>
            <div
              className="submitBtn__Arrow"
              style={{
                width: "32px",
                height: "32px",
                backgroundColor: "#FFFFFF",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginLeft: "10px",
              }}
            >
              <ArrowForwardIcon style={{ fontSize: "24px" }} />
            </div>
          </Link>
        </Box>
      </Paper>

      <Technologies />
      </Box>
  );
};
export default ProductEngineering;
